import http from "../httpService";
import {getBaseUrl} from "../../config";

export const getSupportStats = (signal) => {
  return http.get(`${getBaseUrl()}/support-stats`, { signal });
};

export const getDashboard = () => {

  return http.get(
    `${getBaseUrl()}/dashboard`,
  );
};

export const getTodayWorksCount = () => {

  return http.get(
    `${getBaseUrl()}/admin_dashboard_today_work_count`,
  );
};

export const getWorksCount = () => {

  return http.get(
    `${getBaseUrl()}/admin_dashboard_work_count`,
  );
};
